module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sign-up-team",
    attrs: {
      "id": "section-sign-up-team"
    }
  }, [_c('form-dynamix', {
    attrs: {
      "type": "team",
      "feedback": _vm.feedback,
      "loading": _vm.loading,
      "names": _vm.names,
      "models": _vm.models,
      "attributes": _vm.attributes,
      "vuelidate": _vm.$v,
      "is-print": _vm.isPrint,
      "is-print-pdf": _vm.isPrintPdf
    },
    on: {
      "recaptcha": _vm.onRecaptcha,
      "send": _vm.onSend
    }
  }), _vm._v(" "), _c('b-modal', {
    staticClass: "modal-wrapper",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "scroll": "keep",
      "active": _vm.isMapModalActive
    },
    on: {
      "update:active": function($event) {
        _vm.isMapModalActive = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "white",
      "padding": "12px 8px 3px 8px",
      "font-weight": "bold",
      "font-size": "0.9em"
    }
  }, [(_vm.markerCurrent !== undefined) ? _c('span', [_vm._v("\n        Choose " + _vm._s(_vm.markerCurrent.attributes.title) + " desired location.\n      ")]) : _c('span', [_vm._v("\n        Choose all five desired locations.\n      ")])]), _vm._v(" "), _c('p', {
    staticClass: "image is-4by3",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "relative",
      "background-color": "white",
      "margin-bottom": "0"
    }
  }, [(_vm.isDesktop) ? _c('img', {
    ref: "mapRef",
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%",
      "height": "auto",
      "display": "inline-block"
    },
    attrs: {
      "src": require("../assets/map.png")
    }
  }) : _c('a', {
    attrs: {
      "href": _vm.imageMapSrc,
      "target": "_blank"
    }
  }, [_c('img', {
    ref: "mapRef",
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%",
      "display": "inline-block"
    },
    attrs: {
      "src": require("../assets/map.png")
    }
  })])]), (!_vm.isDesktop) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background-color": "white"
    }
  }, [_vm._v("\n        (click to open map in a new tab)\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.markerList), function(marker) {
    return (_vm.isDesktop) ? _c('div', {
      key: marker.text,
      staticClass: "marker",
      class: {
        'disabled': marker.state === 0,
        'enabled': marker.state === 1,
        'selected': marker.state === 2
      },
      style: ({
        top: marker.top,
        left: marker.left,
        height: _vm.markerHeight
      }),
      on: {
        "click": function($event) {
          return _vm.onClickMapMarker(marker)
        }
      }
    }, [_vm._v("\n        " + _vm._s(marker.text) + "\n        "), (_vm.isDesktop) ? _c('div', {
      staticStyle: {
        "position": "absolute",
        "z-index": "99999",
        "background-color": "rgba(255,255,255,0.5)",
        "font-size": "0.8em",
        "font-weight": "bold"
      },
      style: ({
        top: marker.selTop,
        bottom: marker.selBottom,
        left: marker.selLeft,
        right: marker.selRight
      })
    }, [_vm._v("\n          " + _vm._s(marker.textSelected) + "\n        ")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (false && _vm.isDesktop && _vm.markerCurrent === undefined) ? _c('div', {
    staticClass: "marker",
    staticStyle: {
      "position": "absolute",
      "padding-left": "8px",
      "padding-right": "8px",
      "background-color": "rgba(255,255,255,0.5)"
    },
    style: ({
      top: _vm.markerClear.top,
      left: _vm.markerClear.left,
      height: _vm.markerHeight,
      width: 'auto'
    }),
    on: {
      "click": function($event) {
        return _vm.onResetMapMarker()
      }
    }
  }, [_vm._v("\n        Reset All Locations\n      ")]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), (!_vm.isDesktop) ? _c('div', {
    staticClass: "columns is-multiline is-mobile is-centered is-gapless",
    staticStyle: {
      "text-align": "center",
      "background-color": "rgba(255,255,255,0.5)",
      "margin-bottom": "0"
    }
  }, _vm._l((_vm.markerList), function(marker) {
    return _c('div', {
      key: marker.text,
      staticClass: "column is-narrow"
    }, [_c('div', {
      staticClass: "marker static",
      class: {
        'disabled': marker.state === 0,
        'enabled': marker.state === 1,
        'selected': marker.state === 2
      },
      staticStyle: {
        "display": "inline-block",
        "margin": "3px auto",
        "padding": "3px 15px",
        "text-align": "center"
      },
      on: {
        "click": function($event) {
          return _vm.onClickMapMarker(marker)
        }
      }
    }, [_vm._v("\n          " + _vm._s(marker.text) + "\n          "), _c('div', {
      staticStyle: {
        "font-size": "0.7em",
        "font-weight": "bold"
      }
    }, [_vm._v("\n            " + _vm._s(marker.textSelected) + "\n          ")])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline is-mobile is-centered is-gapless",
    staticStyle: {
      "text-align": "center",
      "background-color": "white"
    }
  }, [(_vm.markerCurrent === undefined) ? _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "marker static",
    staticStyle: {
      "display": "inline-block",
      "margin": "5px auto 18px auto",
      "padding": "5px 12px",
      "text-align": "center",
      "background-color": "rgba(255,255,255,0.5)"
    },
    on: {
      "click": function($event) {
        return _vm.onResetMapMarker()
      }
    }
  }, [_vm._v("\n          Reset All Locations\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "marker static",
    staticStyle: {
      "display": "inline-block",
      "margin": "5px auto 18px auto",
      "padding": "5px 12px",
      "text-align": "center",
      "background-color": "rgba(10,30,200,0.5)",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.onProceed()
      }
    }
  }, [_vm._v("\n          Proceed\n        ")])])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-160de1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SignUpTeamSection.vue
// module id = 902
// module chunks = 1